import { KTSVG } from '_metronic/helpers'

interface Props {
  filter: any
  onChangeFilter: (name: string, value: any) => void
  onClearFilter: () => void
  onSubmit: () => void
}

const Filter: React.FC<Props> = ({ filter, onChangeFilter, onClearFilter, onSubmit }) => {
  return (
    <div
      id='kt_sale_order_filter'
      className='bg-body'
      data-kt-drawer='true'
      data-kt-drawer-name='chat'
      data-kt-drawer-activate='true'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'300px', 'md': '500px'}"
      data-kt-drawer-direction='end'
      data-kt-drawer-toggle='#kt_sale_order_filter_toggle'
      data-kt-drawer-close='#kt_sale_order_filter_close'>
      <div className='card w-100 rounded-0'>
        <div className='card-header pe-5'>
          <div className='card-title'>
            {/* begin:: Title */}
            <div className='d-flex justify-content-center flex-column me-3'>
              <span className='fs-4 fw-bolder text-gray-900 text-hover-primary me-1 mb-2 lh-1'>
                ค้นหา
              </span>
            </div>
            {/* end:: Title */}
          </div>

          <div className='card-toolbar'>
            {/* begin:: Close Button */}
            <button
              className='btn btn-sm btn-bg-white btn-active-light-danger text-center'
              id='kt_sale_order_filter_close'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr015.svg'
                className='svg-icon svg-icon-2x mx-auto'
              />
            </button>
            {/* end:: Close Button */}
          </div>
        </div>

        <div className='card-body'>
          <div
            data-kt-element='messages'
            data-kt-scroll='true'
            data-kt-scroll-activate='{default: false, lg: true}'
            data-kt-scroll-max-height='auto'
            data-kt-scroll-offset='5px'>
            <div className='row gy-5'>
              {/* <div className='col-12'>
                <div className='fs-6 mb-3'>Sale Order ID</div>

                <input type='text' className='form-control form-control-sm' placeholder='' />
              </div> */}

              {/* begin:: Sale Title */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>Sale Order ID.</div>
                <input
                  type='text'
                  className='form-control form-control-sm'
                  value={filter.code}
                  onChange={(e: any) => onChangeFilter('code', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_sale_order_filter_close')?.click()
                    }
                  }}
                />
              </div>
              {/* end:: Sale Title */}

              {/* begin:: Sale Title */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อผู้ขาย</div>
                <input
                  type='text'
                  className='form-control form-control-sm'
                  value={filter.saleTitle}
                  onChange={(e: any) => onChangeFilter('saleTitle', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_sale_order_filter_close')?.click()
                    }
                  }}
                />
              </div>
              {/* end:: Sale Title */}

              {/* begin:: Customer */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อลูกค้า</div>
                <input
                  type='text'
                  className='form-control form-control-sm'
                  value={filter.customerTitle}
                  onChange={(e: any) => onChangeFilter('customerTitle', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_sale_order_filter_close')?.click()
                    }
                  }}
                />
              </div>
              {/* end:: Customer */}

              {/* begin:: Division */}
              <div className='col-12'>
                <div className='fs-6 mb-3'>ชื่อหน่วยงาน</div>
                <input
                  type='text'
                  className='form-control form-control-sm'
                  value={filter.division}
                  onChange={(e: any) => onChangeFilter('division', e.target.value)}
                  onKeyDown={(e: any) => {
                    if (e.key === 'Enter') {
                      onSubmit()
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      document.querySelector('#kt_sale_order_filter_close')?.click()
                    }
                  }}
                />
              </div>
              {/* end:: Division */}

              <div className='col-12 d-flex flex-row'>
                <button
                  className='btn btn-sm btn-primary me-4 w-50 fw-bold'
                  onClick={onSubmit}
                  id='kt_sale_order_filter_close'>
                  Search
                </button>
                <button
                  className='btn btn-sm btn-danger w-50 fw-bolder'
                  onClick={onClearFilter}
                  id='kt_sale_order_filter_close'>
                  Clear
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Filter
